exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "ul.FullBleedList-67190850{margin:0 0}ul.FullBleedList-67190850 li:hover{border-top:1px solid #eee;margin:-1px -20px 0 -20px;padding:7px 20px 7px 20px}\n", ""]);

// Exports
exports.locals = {
	"FullBleedList": "FullBleedList-67190850"
};